import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.shape.componentSpacing,
  },
  tabsContainer: {
    marginTop: pxToRem(24),
    [theme.breakpoints.up('lg')]: {
      marginTop: pxToRem(30),
    },
  },
  title: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(5),
    },
  },
}));

export default useStyles;
